<div class="container d-flex justify-content-center">
    <div class="d-flex flex-column mt-4 form-wrapper">
        <h2>Login</h2>

        <form [formGroup]="loginForm" (ngSubmit)="onLoginFormSubmit()">
            <div>
                <mat-form-field class="w-100">
                    <input
                        matInput
                        placeholder="Email"
                        formControlName="email"
                        name="email"
                        type="email"
                    />
                    <mat-error
                        *ngIf="
                            loginForm.controls.email.hasError('email') &&
                            !loginForm.controls.email.hasError('required')
                        "
                    >
                        Please enter a valid email address
                    </mat-error>
                    <mat-error
                        *ngIf="loginForm.controls.email.hasError('required')"
                    >
                        Email is required
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="mt-3">
                <mat-form-field class="w-100">
                    <input
                        matInput
                        placeholder="Password"
                        formControlName="password"
                        name="password"
                        type="password"
                    />
                    <mat-error
                        *ngIf="loginForm.controls.password.hasError('required')"
                    >
                        Password is required
                    </mat-error>
                </mat-form-field>
            </div>

            <div
                *ngIf="hasError"
                class="form-error-row d-flex align-items-center mb-3"
            >
                <mat-icon>error_outline</mat-icon>
                <span>Wrong username or password.</span>
            </div>

            <div class="mt-3">
                <button
                    mat-raised-button
                    color="primary"
                    [disabled]="!loginForm.valid"
                    type="submit"
                >
                    Login
                </button>
            </div>

            <div class="mt-3">
                <button class="link-button" (click)="openResetPasswordDialog()">
                    Forgot your password?
                </button>
            </div>
        </form>
    </div>
</div>
